import React from 'react'
import LoggedInLayout from '../../layout/LoggedInLayout'
import { Box } from '@mui/material'

const AICareerBuddy = () => {
  return (
    <LoggedInLayout>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh", // adjust if you want full height
        }}
      >
        <img
          src="/assets/newImages/cb-cs.jpeg"
          alt="AI Career Buddy Coming Soon"
          style={{
            maxWidth: "100%",
            height: "auto",
          }}
        />
      </Box>
    </LoggedInLayout>
  )
}

export default AICareerBuddy